import React from "react";


export default function Hero() {
 
  const handleScroll = (sectionId) => {
    const target = document.getElementById(sectionId);
    if (target) {
      const offset = 80; // Adjust based on navbar height
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }};

  const heroStyle = {
    position: "relative",
    height: "100vh",
    backgroundImage: "url('/assets/images/Siemens-Logo-PLC.jpg')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
    color: "white",
    textAlign: "center",
    overflow: "hidden"
  };

  return (
    <section id="home" style={heroStyle}>
      <div style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 1
      }}></div>

      <div style={{
        position: "relative",
        zIndex: 2,
        maxWidth: "800px"
      }}>
        <h1 style={{ fontSize: "3rem", fontWeight: "700", marginBottom: "20px" }}>
          RK Industrial Automation Systems
        </h1>
        <p style={{ fontSize: "1.1rem", marginBottom: "30px" }}>
          R K Industrial Automation System is a one-stop shop for comprehensive automation
          solutions with process system engineering, automation systems supply, services, and
          commissioning.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <button
            style={{
              padding: "12px 24px",
              borderRadius: "30px",
              fontSize: "1rem",
              fontWeight: 600,
              backgroundColor: "orange",
              color: "white",
              border: "none",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
             onClick={() => handleScroll("services")}
          >
            Our Services
          </button>

          <button
            style={{
              padding: "12px 24px",
              borderRadius: "30px",
              fontSize: "1rem",
              fontWeight: 600,
              backgroundColor: "transparent",
              color: "white",
              border: "2px solid white",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onClick={()=> handleScroll("contactform")}
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}
